import React, { useState } from "react";
import { AppListing } from "../../../../components/appListing";
import { intervationsRadiologyCols, interventionsOtherCols } from "../../constant";
import { FaComments } from "react-icons/fa";
import moment from "moment";
import MainPageDialog from "../../../../components/mainPageDialog";
import CareplanEducations from "../careplan_educations";

const CareplanInterventions = ({
  labsData = [],
  radiologyData = [],
  educationData = [],
  otherInterventionsData = [],
  loading = false,
  legacyMode = false,
}) => {
  const [interventionTypes, setInterventionType] = useState("labs");
  const [labsComments, setLabsComments] = useState("");
  const [labsCommentsDialog, setLabsCommentsDialog] = useState(false);

  const handleClick = (type) => {
    setInterventionType(type);
  };

  const handleLabsComments = (comments) => {
    setLabsComments(comments);
    setLabsCommentsDialog(true);
  };

  const interventionsCols = [
    {
      title: "Date",
      key: "order_datetime",
      getData: (data) => {
        const originalDate =
          data?.order_datetime !== ""
            ? moment(data?.order_datetime).format("l")
            : "";
        return originalDate;
      },
    },
    { title: "Order #", key: "order_number" },
    { title: "Lab", key: "lab_name" },
    { title: "Provider", key: "ordering_provider_name" },
    { title: "Assign To", key: "assign_to_name" },
    {
      title: "Status",
      key: "status",
      getData: (item) =>
        item?.status ? <div className="capitalize">{item?.status}</div> : "-",
    },
    {
      title: "",
      key: "comments",
      colClass: "col-md-1 text-center",
      getData: (item) => (
        item?.comments !== '' &&
        <div className="flex w-[100%] items-start justify-start px-2 text-blue-500 text-lg hover:text-blue-900">
          <FaComments />
        </div>
      ),
      onClick: (item) => handleLabsComments(item?.comments),
    },
  ];

  const groupedOtherInterventions = otherInterventionsData.reduce((acc, item) => {
    const type = item?.ccm_type || "Other";
    const existing = acc.find((group) => group.type === type);
    if (existing) {
      existing.other_interventions.push(item);
    } else {
      acc.push({ type, other_interventions: [item] });
    }
    return acc;
  }, []);

  return (
    <>
      <div className="mt-5 ">
        <button
          className={`p-1 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            interventionTypes === "labs" && "bg-blue-500 text-white"
          }`}
          onClick={() => handleClick("labs")}
        >
          {" "}
          Labs{" "}
        </button>
        <button
          className={`p-1 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            interventionTypes === "radiology" && "bg-blue-500 text-white"
          }`}
          onClick={() => handleClick("radiology")}
        >
          {" "}
          Radiology{" "}
        </button>
        <button
          className={`p-1 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            interventionTypes === "education" && "bg-blue-500 text-white"
          }`}
          onClick={() => handleClick("education")}
        >
          {" "}
          Education{" "}
        </button>
        <button
          className={`p-1 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            interventionTypes === "other" && "bg-blue-500 text-white"
          }`}
          onClick={() => handleClick("other")}
        >
          {" "}
          Other{" "}
        </button>

        <div className="py-2">
          {interventionTypes === "labs" ? (
            <AppListing
              loading={loading}
              listData={labsData}
              cols={interventionsCols}
            />
          ) : interventionTypes === "radiology" ? (
            <AppListing
              loading={loading}
              listData={radiologyData}
              cols={intervationsRadiologyCols}
            />
          ) : interventionTypes === "education" ? (
            <CareplanEducations listData={educationData} loading={loading} legacyMode={legacyMode} />
          ) : (
            <div className="py-2">
              {groupedOtherInterventions.map((v) => (
                <div>
                  <p className="text-red-400 text-xl font-bold py-5">
                    {v.type}
                  </p>
                  <AppListing
                    loading={loading}
                    listData={v.other_interventions || []}
                    cols={interventionsOtherCols}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {labsCommentsDialog && (
        <MainPageDialog
          title="Comments"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setLabsCommentsDialog(null),
            },
          ]}
          onCancelHandler={() => setLabsCommentsDialog(null)}
        >
          {labsComments === "" ? "No comments added." : labsCommentsDialog}
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanInterventions;
